<template>
  <div id="container">
    <div id="main">

      <header class="home-header">
        <nav-bar/>
      </header>
      <div class="joinus">
        <span
          style="font-size: 25px; font-weight: bold; margin: 60px 0 20px 0;">东南大学智能原生物联网实验室（SAIL）招收2025级硕士生、博士生</span>
        <van-divider/>
        <div class="intro">
          <span style="color: #4d5156; font-weight: bold;">东南大学计算机、软件、人工智能学院智能原生物联网实验室（SAIL）</span>,
          <span style="line-height: 50px">
            现招收2025级硕士生、博士生！
          </span>
        </div>
        <van-divider/>
        <span class="subtitle">实验室简介</span>
        <div class="intro" style="line-height: 50px">
          东南大学智能原生物联网实验室（SEU AI-native IoT Lab, SAIL）由IEEE/ACM Fellow何田教授和东南大学青年首席教授王帅于2018年11月创立，研究的主要领域包括智慧物联网、边缘计算、序列建模、知识推理、大数据分析及其应用等。现实验室研究分为三个大方向，分别是由李博睿老师负责的智能原生计算，由林丽老师负责的时空大数据分析与多模态推理，以及由王帅老师负责的智能原生通信与感知。
        </div>
        <van-divider/>
        <span class="subtitle">团队构成</span>
        <div class="prof-list">
          <div v-for="prof in profList1" v-bind:key="prof.index" class="card">
            <img :src="prof.imgUrl">
            <div class="col">
              <a :href="prof.pageUrl"><span>{{ prof.chi }}</span> <br/>
                <span style="font-size: 16px; font-weight: normal">{{ prof.name }}</span></a>
            </div>
          </div>
        </div>
        <div class="prof-list">
          <div v-for="prof in profList2" v-bind:key="prof.index" class="card">
            <img :src="prof.imgUrl">
            <div class="col">
              <a :href="prof.pageUrl"><span>{{ prof.chi }}</span> <br/>
                <span style="font-size: 16px; font-weight: normal">{{ prof.name }}</span></a>
            </div>
          </div>
        </div>
        <van-divider/>
        <van-divider/>
        <span class="subtitle">学生培养</span>
        <div class="intro" style="line-height: 50px">
          实验室拥有浓厚的科研氛围，导师会针对学生的不同特点制定不同的培养方案。此外，实验室与罗格斯大学、韦恩州立大学、明尼苏达大学、香港城市大学等多所国际知名大学开展学生联合培养工作。
          2024年实验室的共有2名博士生，16名硕士生顺利毕业。毕业去向包含，博士后2人，境外高校深造1人，中央部委/选调4人，国家高新技术企业2人，互联网科技公司9人（京东、腾讯、深信服等）
        </div>
        <van-divider/>
        <span class="subtitle">国际交流</span>
        <div class="intro" style="line-height: 50px">
          参与课题的同学可直接参加国外合作课题组的组会，安排合作课题组教授对课题进行细致的指导。实验室提倡做出高水平成果，并有着充足的科研经费保障课题的进行，对于优秀的学生也非常乐意派其参加国内外高水平会议和前往国外合作课题组进行访问学习。
        </div>
        <span class="subtitle">团队氛围</span>
        <div class="intro" style="line-height: 50px">
          实验室行政体系完善、氛围融洽，非常重视和支持同学们的集体生活，定期组织各种团建活动。
        </div>
        <span class="subtitle">学术交流</span>
        <div class="intro" style="line-height: 50px">
          实验室与南洋理工大学、香港城市大学、香港科技大学、明尼苏达大学、乔治梅森大学、罗格斯大学、韦恩州立大学、清华大学、北京大学、浙江大学等海内外学校有长期交流合作。乐意派同学们参加国内外高水平会议和前往国外合作课题组进行访问学习。在读博士曾赴英国、加拿大、新加坡等地CSC交流访问。
        </div>
        <span class="subtitle">企业实践</span>
        <div class="intro" style="line-height: 50px">
          与京东、字节跳动、中国移动、徐工集团以及其他国有/私有企业有相关科研合作项目，有意向的同学可以由导师推荐前往实习。
        </div>
        <span class="subtitle">招生信息</span>
        <div class="intro" style="line-height: 50px">
          博士招生要求：<br>
          (1) 985/211或双一流高校/专业毕业（如有突出的科研成绩，相关要求可酌情放宽）；<br>
          (2) 在本科或硕士阶段，以第一作者（或导师一作）在人工智能、计算机网络、计算机系统等相关领域有国际高水平论文发表经历（CCF Rank论文、SCI一区二区论文），拥有 CCF A 类论文发表的优先录取；<br>
          (3) 拥有丰富的科研项目研究经验，和较好的中英读写能力。<br><br>
          硕士招生要求（考研）：<br>
          (1) 通过东南大学研究生入学考试笔试与面试选拔，拥有较好的中英读写能力；<br>
          (2) 有在人工智能、计算机网络、计算机系统等相关领域有论文发表经历的优先；<br>
          (3) 同时欢迎2026保研的同学申请。<br><br>
          希望学生能保持稳定且适当的科研、娱乐和锻炼时间，希望学生能按时毕业！
          个人主页请搜索老师的名字+东南大学个人主页，可通过老师个人主页提供的邮件联系方式，在邮件中说明你的兴趣方向、原因，并附上个人简历、成绩单、英文水平证明、代表性研究成果、博士攻读计划或博士研究兴趣（博士生需要）。
        </div>
        <div style="font-size: 25px; font-weight: bold; margin: 30px 0 80px 0;">
          快来加入我们吧，开启你的科研之旅！欢迎关注实验室公众号“SAIL实验室”，获取更多信息。
        </div>
      </div>
    </div>

    <footer-info/>
  </div>
</template>

<script>
import navBar from '@/components/NavBar'
import footerInfo from '@/components/FooterInfo'

export default {
  data() {
    return {
      directionList: [
        {
          name: '大数据分析',
          desc: '大量的物联网设备会产生各式各样的数据，如何设计高效的系统去处理并应用这些数据是一个前景广阔的研究方向。实验室基于数据驱动去研究并解决实际生活中的许多问题，如共享单车的平衡调度、电动公交车队的电池寿命感知、蜂窝数据的用量预测等。'
        },
        {
          name: '智慧物联网',
          desc: '物联网设备数量正在以一个飞快的速度增长，如何更加智能化地连接、使用这些设备成为了一个非常具有科研和应用价值的方向。具体来说，研究异构直联通信技术使得不同的无线通信协议如WiFi、ZigBee和Bluetooth等能够免网关进行通信。研究计算机视觉和物联网设备感知相结合的技术，利用不同传感器收集的数据进行融合从而解决某些场景下相应的问题等。'
        },
      ],
      profList1: [
        {
          'name': 'SHUAI WANG',
          'chi': "王帅",
          'imgUrl': require('../assets/people/wangshuai.jpg'),
          'pageUrl': 'https://cse.seu.edu.cn/2019/0107/c23024a257643/page.htm'
        }],
      profList2: [
        {
          'name': 'WEIWEI CHEN',
          'chi': '陈巍巍',
          'imgUrl': require('../assets/people/chenweiwei.jpg'),
          'pageUrl': 'https://cse.seu.edu.cn/2020/0913/c23024a345536/page.htm'
        },
        {
          'name': 'LI LIN',
          'chi': '林丽',
          'imgUrl': require('../assets/people/linli.jpeg'),
          'pageUrl': 'https://cse.seu.edu.cn/2022/0901/c23024a418636/page.htm'
        },
        {
          'name': 'BORUI LI',
          'chi': '李博睿',
          'imgUrl': require('../assets/people/liborui.png'),
          'pageUrl': 'https://cse.seu.edu.cn/2022/1124/c10343a429174/page.htm'
        },
        {
          'name': 'SHUAI WANG',
          'chi': '王帅',
          'imgUrl': require('../assets/people/xiaoshuai.jpg'),
          'pageUrl': 'https://cs.seu.edu.cn/shuaiwang_iot/main.htm'
        },
      ]

    }
  },
  components: {
    navBar,
    footerInfo
  }
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';

#container {
  position: relative;
}

#main {
  padding-bottom: 150px;
}

.home-header {
  position: fixed;
  left: 0;
  top: 0;
  .wh(100%, 40px);
  .fj();
  line-height: 40px;
  .boxSizing();
  font-size: 12px;
  color: #fff;
  z-index: 10000;
  box-shadow: 0 0 4px 0 @theme-color;
}

.prof-list {
  display: flex;
  width: 100%;
  padding-top: 15px;
  flex-direction: row;
  .fj(space-around);
  padding-bottom: 15px;

  .card {
    width: 30%;
    margin-bottom: 15px;

    color: #4d5156;
    background-color: #fefefe;

    flex-direction: row;
    text-align: center;
    .fj(space-around);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    img {
      .wh(100px, 120px);
      border-radius: 8px;
      margin: 5px 3px;
    }

    &:hover {
      background-color: #fff;
    }

    .col {
      width: 80%;
      color: #4d5156;
      background-color: #fefefe;
      flex-direction: column;
      text-align: left;
      .fj(center);

      a {
        padding-top: 10px;

        :hover {
          color: @theme-color;
        }
      }

      span {
        padding-left: 10px;
        font-size: 15px;
        font-weight: bold;
        text-align: left;
      }
    }

  }

}

.joinus {
  .fj(center);
  margin-top: 40px;
  width: 72%;
  padding-left: 15%;
  flex-direction: column;
  text-align: center;


  .intro {
    text-align: left;
    font-size: 14px;
    margin: 15px 0;
  }

  .subtitle {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
  }
}
</style>
